"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_2_minimap = _interopRequireDefault(require("../images/help_2_minimap.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var miniMap = {
  id: "miniMap",
  title: {
    en: "Mini map",
    de: "Mini-Karte"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_2_minimap.default,
      alt: "",
      style: {
        width: "390px",
        height: "333px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Mini map(Shortcut key : M)"), /*#__PURE__*/_react.default.createElement("p", null, "Mini map will let characters see the area, and during party creation mode it will show location of party members."), /*#__PURE__*/_react.default.createElement("p", null, "Direction of the character will shown by the triangle in the middle of the map. The sharp point will show the direction which character is facing."), /*#__PURE__*/_react.default.createElement("p", null, "Size of the mini map can be magnified up to 2x, and press +button to increase it's size."), /*#__PURE__*/_react.default.createElement("p", null, "If you press the round button, you can view entire Idios continent, and also you can mark in the map."), /*#__PURE__*/_react.default.createElement("p", null, "Marking is to help you to come back to the place later if you want to revisit at the place you have marked. Under the world map type your message and then press small pencil icon to mark. To erase, select the mark and then press eraser to delete."), /*#__PURE__*/_react.default.createElement("p", null, "In mini map's special place, NPC user marking is marked and in world map only user marking can mark."))
  }
};
var _default = miniMap;
exports.default = _default;